
import store from '../store'

import app from '../main'

import moment from "moment"
require('moment/locale/tr')


export const evaluation = {

	data() {
		return {
			
		};
	},

	methods:{

		getSubsectionInputfields(section_id)
		{

		},
		orderSection( a, b ) {
		  if ( a.queue < b.queue ){
		    return -1;
		  }
		  if ( a.queue > b.queue ){
		    return 1;
		  }
		  return 0;
		},
		
		async arrangeAuditInputfields(data)
	    {
	    	
	        
	        let inputfields = await data.inputfields
	        let sections = await data.sections
	        	        
	        await store.dispatch('evaluation/setSections',sections)
	        await store.dispatch('evaluation/setInputfields',inputfields)

	        for(let section of sections)
	        {
	        	section = await this.checkSingleSectionCompletion(section)
	        }

	        await this.checkQueslionlistConditions()
	        inputfields = await this.$store.state.evaluation.inputfields
	        //inputfields = await inputfields.sort(this.orderSection)
	        for(let item of inputfields)
	        {
	        	item = await this.checkSingleInputfieldCompletion(item)
	        }
	        
	        

	        let parentsections = await sections.filter((item)=>{return item.parent_id == 0})
	        parentsections  = await parentsections.sort(this.orderSection)


	        

	        await store.dispatch('evaluation/setParentSections',parentsections) 
	        await store.dispatch('evaluation/setInputfields',inputfields)
	        await store.dispatch('evaluation/setSections',sections)
	        await store.dispatch('evaluation/setActiveParentSectionId',null) 
	        
	        
	    },
	    async checkSubSectionFinishData(section)
	    {
	    	let status = await true
	    	let inputfields = await store.state.evaluation.inputfields
	    	let sections = await store.state.evaluation.sections

	    	let subsections = await sections.filter((item)=>{return item.parent_id == section.id && item.show_section===1})
	    	
	    	if(subsections.length)
	    	{
	    		//console.log("subsections")
	    		//console.log(subsections)
	    		subsections  = await  subsections.sort(this.orderSection)
	    		for (let i = 0; i <subsections.length; i++) {

	    			let section_check = await this.checkSubSectionFinishData(subsections[i])
	    			if(!section_check)
	    			{
	    				status = await false
	    				break
	    			}
	    		}
	    	}
	    	let section_inputfields = await inputfields.filter((item)=>{return item.inputfieldsection_id == section.id})
	    	
	    	if(section_inputfields.length)
	    	{
	    		//console.log("section_inputfields")
	    		//console.log(section_inputfields)
	    		section_inputfields  =  await section_inputfields.sort(this.orderSection)
	    		for (let i = 0; i <section_inputfields.length; i++) {

	    			let inputfield_check = await this.checkInputfieldFinishStatus(section_inputfields[i])
	    			if(!inputfield_check)
	    			{

	    				status = await false
	    				break
	    			}
	    		}
	    	}
	    return await status
	    },
	    async checkInputfieldFinishStatus(inputfield)
	    {
	    	let status = await true
	    	if(inputfield.show_field)
	    		{
	    			if(inputfield.is_required)
	    			{
	    				if(!inputfield.completion)
	    				{
	    					
	    					status = await false
	    					await store.dispatch('evaluation/setFirstInputfieldError',inputfield)	    					
	    				}
	    				else
	    				{
	    					status = await true
	    				}
	    			}
	    			else
	    			{
	    				status = await true
	    			}
	    		}
	    	
	    	return await status
	    },

	    async checkReadyToFinish()
	    {
	    	let status = true
	    	let sections = store.state.evaluation.sections
	    	let parentsections = sections.filter((item)=>{return item.parent_id == 0})	    	
	    	parentsections  =  parentsections.sort(this.orderSection)
	    	for (let i = 0; i <parentsections.length; i++) {
	    		let check = await this.checkSubSectionFinishData(parentsections[i])	    		
	    		if(!check)
	    		{

	    			status = false
	    			break
	    		}
	    	}
	    	return status

	    },
	    async checkCustomAttributesReadyToFinish()
	    {
	    	let status = true
	    	console.log(this.$store.state.audit.audit.flowsupplier.flow.flowattributes)
	    	let attributes = this.sanitizeArray(this.$store.state.audit.audit.flowsupplier.flow.flowattributes)
	    	for (let i = 0; i < attributes.length; i++)
	    	{
	    		let attribute = attributes[i]
	    		if(attribute.is_required)
	    		{
	    			let submission = attribute.customattribute.supplierattributes[0]
	    			if(attribute.customattribute.type=="select" && !submission.attibutenumericalval)
	    			{
	    				if(submission.attibutenumericalval!==0)
	    				{
	    					status = false
		    				store.dispatch('audit/setMissingAttribute',true)
		    				break
	    				}
	    				
	    			}
	    			if(attribute.customattribute.type=="number" && !submission.attibutenumericalval)
	    			{
	    				if(submission.attibutenumericalval!==0)
	    				{
	    					status = false
		    				store.dispatch('audit/setMissingAttribute',true)
		    				break
	    				}
	    			}
	    			if(attribute.customattribute.type=="string" && !submission.attibutetextval)
	    			{
	    				status = false
	    				store.dispatch('audit/setMissingAttribute',true)
	    				break
	    			}
	    		}
	    	}
	    	return status

	    },

	    checkSingleSectionCompletion(item)
	    {

	    	item.show_field = 1
	    	if(!item.show_section)
	    	{
	    		item.show_field = 0
	    	}
	    	return item
	    },
	    checkInputfieldSectionVisibility(item)
	    {
	    	let sections = this.$store.state.evaluation.sections
	    	let item_section = sections.find(element=> element.id == item.inputfieldsection_id)
	    	if(item_section)
	    	{
	    		if(item_section.parent_id===0)
	    		{
	    			return item_section.show_section
	    		}
	    		else
	    		{
	    			let visibility = this.getSectionParentVisibility(item_section)
	    			if(!visibility)
	    			{
	    				return 0
	    			}
	    			return item_section.show_section
	    		}
	    	}
	    	return 0
	    },
		getSectionParentVisibility(section)
		{
			let sections = this.$store.state.evaluation.sections
			let parent = sections.find(item=>item.id == section.parent_id)
			if(parent)
			{
				if(parent.parent_id===0)
				{
					return parent.show_section
				}
				else
				{
					return this.getSectionParentVisibility(parent)
				}
			}
			return false

		},
	    async checkSingleInputfieldCompletion(item)
	    {
	    	console.log("checkSingleInputfieldCompletion")
	    	let submission = null
	    	let evidences = []
	    	let completion = false
	    	let submittable =false
	    	let show_evidence_btn = false
	    	let show_info_textarea = false
	    	let submission_made = false
	    	let evidences_submitted = false
	    	let submission_note_submitted = false
	    	let read_only_state = false
	    	let show_completion_indicator = true
	    	let read_only_question = false
	    	let section_visible = this.checkInputfieldSectionVisibility(item)
	    	
	    	
	    	if(!section_visible)
	    	{
	    		item.hidden_by_section = true
	    	}
	    	else
	    	{
	    		item.hidden_by_section = false
	    	}
	    	
	    	if(item.columns.length)
	    	{
	    		item.columns = item.columns.filter((element)=>{return element.active})
	    	}

	    	if(item.options.length)
	    	{
	    		item.options = item.options.filter((element)=>{return element.active})
	    	}

	    	if(item.submissions && item.submissions.length)
	    	{
	    		submission = item.submissions[0]
	    		if(submission.evidences && submission.evidences.length)
	    		{
	    			evidences = submission.evidences
	    		}
	    	}
	    	
	    	if(item.ask_for_submission_note && item.submission_note_show_type=="always")
	    	{
	    		show_info_textarea = true
	    	}
	    	////////////////////////

	    	//submission made
	    	if(item.type=="readonlytext")
    		{
    			show_completion_indicator = false
    			read_only_question = true
    		}

    		//readonlytext

    		//check for calc-readonly columns
    		if(item.type=="columns")
    		{
    			//check for indicator
    			for (let iii = 0; iii < item.columns.length; iii++) {
				  if(item.columns[iii].type=="text" || item.columns[iii].type=="number" || item.columns[iii].type=="select")
				  {
				  	show_completion_indicator = true
				  	break;
				  }
				  else
				  {
				  	show_completion_indicator = false
				  }
				}
				//check for indicator
				//check for completion
				for (let iii = 0; iii < item.columns.length; iii++) {
					if(item.columns[iii].type=="custom" || item.columns[iii].type=="readonly")
					  {
					  	read_only_question = true
					  	
					  }
					  else
					  {
					  	read_only_question = false
					  	break;
					  }

				}
				//check for completion


    		}
	    		//check for calc-readonly columns
	    	if(submission)
	    	{
	    		//check field submissions
	    		//text type,longtext
	    		if(item.type=="text" || item.type=="longtext")
	    		{
	    			let submission_text = submission.submission_text
	    			if(submission_text && submission_text!=="")
	    			{

	    				submission_made = true
	    			}
	    		}
	    		//text type,longtext

	    		//text type,longtext
	    		if(item.type=="location")
	    		{
	    			let submission_text = submission.submission_text
	    			if(submission_text && submission_text!=="")
	    			{
	    				let submission_text_obj = JSON.parse(submission_text)
	    				if(!submission_text_obj.country_id || 
	    					!submission_text_obj.city_id || 
	    					!submission_text_obj.address || 
	    					!submission_text_obj.latitude || 
	    					!submission_text_obj.longitude)
	    				{	    					
	    					submission_made = false
	    				}
	    				else
	    				{
	    					if(item.is_postalcode_required && submission_text_obj.postalcode)
	    					{
	    						submission_made = true
	    					}
	    					else
	    					{
	    						submission_made = false
	    					}	    					
	    				}
	    				
	    			}
	    		}
	    		//text type,longtext

	    		if(item.type=="listinput" )
	    		{
	    			let submission_text = submission.submission_text
	    			if(submission_text && submission_text!=="" && submission_text!=="[]")
	    			{
	    				let the_arr = JSON.parse(submission_text)
	    				{
	    					if(the_arr.length>=item.min_item_lenght)
	    					{
	    						submission_made = true
	    						let input_columns = item.columns.filter((thecolumn)=>{return thecolumn.type!=="readonly" && thecolumn.type!=="custom"})
	    						let required_columns = input_columns.filter((thecolumn)=>{return item.is_required ===1})
	    						let required_columns_ids = required_columns.map((thecolumn)=>{return thecolumn.id})
	    						
	    						for (let i = 0; i < the_arr.length; i++) 
	    						{
	    							
	    							let arr_columns = the_arr[i].columns
	    							for (let ii = 0; ii < arr_columns.length; ii++) 
	    							{

	    								if(required_columns_ids.includes(arr_columns[ii].id) && !arr_columns[ii].value)
	    								{
	    									
	    									submission_made = false
	    									break;
	    								}
	    							}

	    						}
	    						

	    						
	    					}
	    				}

	    				
	    			}
	    		}
	    		//text type,longtext

	    		//text number
	    		if(item.type=="number")
	    		{
	    			let submission_numerical = submission.submission_numerical
	    			if(submission_numerical && submission_numerical!=="")
	    			{
	    				submission_made = true
	    			}
	    			if(submission_numerical===0)
	    			{
	    				submission_made = true
	    			}
	    		}
	    		//text number

	    		//text select
	    		if(item.type=="select")
	    		{
	    			
	    			let submission_option = submission.submission_option
	    			if(submission_option && submission_option!=="")
	    			{
	    				submission_made = true
	    			}
	    		}
	    		//text select

	    		//text select
	    		if(item.type=="multiselect" || item.type=="listselect")
	    		{
	    			let submission_text = submission.submission_text
	    			if(submission_text && submission_text!=="[]")
	    			{
	    				
	    				
	    				submission_made = true
	    			}
	    		}
	    		//text select

	    		//text boolean
	    		if(item.type=="boolean")
	    		{
	    			let submission_option = submission.submission_option
	    			if(submission_option===1 || submission_option===0)
	    			{
	    				submission_made = true
	    			}
	    		}
	    		//text boolean
	    		//readonlytext
	    		


	    		//text columns
	    		if(item.type=="columns")
	    		{

	    			let submission_text = submission.submission_text
	    			//if submission_text full
	    			if(submission_text && submission_text!=="[]")
	    			{
	    				
	    				let submission_parsed = JSON.parse(submission.submission_text)
	    				
		    			let input_columns = item.columns.filter((thecolumn)=>{return thecolumn.type!=="readonly"})
		    			let actual_submittables = []
		    			
		    			
		    			//////////
		    			for(let input_column of input_columns)
		    			{
		    				let submitted_column_val = await submission_parsed.find((element)=>{return element.id ==input_column.id })
		    				
		    				if(submitted_column_val)
		    				{
		    					input_column.submitted_column_val = await submitted_column_val.value		    					
		    				}
		    				else
		    				{
		    					if(input_column.type)
		    					{
		    						input_column.submitted_column_val = "calculated"
		    					}
		    					
		    				}
		    				await actual_submittables.push(input_column)
		    			}
		    			//////////
		    			
		    			
		    			//////////

		    			for (let i = 0; i < actual_submittables.length; i++) 
		    			{
		    				//if column required
		    				
		    				if(actual_submittables[i].is_required)
		    				{
		    					
		    					if(actual_submittables[i].submitted_column_val && actual_submittables[i].submitted_column_val!=="")
		    					{

		    						submission_made = await true
		    						
		    					}
		    					else
		    					{
		    						
		    						if(actual_submittables[i].submitted_column_val===0)
		    						{
		    							submission_made = await true
		    						}
		    						else
		    						{
		    							submission_made = await false
		    							break;
		    						}
		    						
		    					}
		    				}
		    				//if column required
		    				//if not column required
		    				else
		    				{
		    					
		    					if(actual_submittables[i].submitted_column_val && actual_submittables[i].submitted_column_val!=="")
		    					{
		    						 
		    						submission_made = true				
		    					}
		    					else
		    					{
		    						if(actual_submittables[i].submitted_column_val===0)
		    						{
		    							submission_made = true	
		    						}
		    					}
		    					
		    				}
		    				//if not column required
		    			}
		    			//////////
	    			}
	    			//if submission_text full
	    			
	    		}
	    		//text columns

	    		

	    		//check field submissions


	    		//check field evidences
	    		if(submission_made && item.ask_for_evidence)
	    		{
	    			show_evidence_btn = true
	    		}
	    		if(evidences.length)
	    		{
	    			evidences_submitted = true
	    		}
	    		//check field evidences

	    		//check field submission_notes
	    		if(submission_made && item.ask_for_submission_note )
	    		{
	    			if(item.submission_note_required)
	    			{	
	    				
	    				if(submission.submission_note && submission.submission_note !=="")
	    				{
	    					
	    					submission_note_submitted = true
	    				}
	    				else
	    				{
	    					
	    					submission_note_submitted = false
	    				}
	    			}
	    		}
	    		//check field submission_notes



	    	}
	    	//submission made

	    	//all conditions checked


	    	

	    	//if is_required
	    	if(item.is_required)
	    	{
	    		//if submission_made
	    		if(submission_made)
	    		{	    
	    					
	    			//if evidence required
	    			if(item.is_evindence_required)
	    			{
	    				if(evidences_submitted)
	    				{
	    					//if note required
			    			if(item.submission_note_required)
		    				{		
		    					 		
		    					if(submission_note_submitted)
			    				{
			    					
			    					completion = true
					    			submittable =true
			    				}
			    				else
			    				{
			    					
			    					completion = false
					    			submittable =false
			    				}
		    				}
			    			//if note required
			    			else
		    				{
		    					completion = true
				    			submittable =true
		    				}
	    				}
	    				else
	    				{
	    					completion = false
			    			submittable =false
	    				}	    				    				
	    			}
	    			//if evidence required
	    			else
	    			{
	    				if(item.submission_note_required)
	    				{		
	    					if(submission_note_submitted)
		    				{
		    					completion = true
				    			submittable =true
		    				}
		    				else
		    				{
		    					completion = false
				    			submittable =false
		    				}
	    				}
		    			//if note required
		    			else
	    				{
	    					completion = true
			    			submittable =true
	    				}
	    			}
    				//if evidence required    				
	    		}
	    		//if submission_made
	    		else
	    		{
	    			completion = false
	    			submittable =false
	    		}
	    	}
	    	//if is_required

	    	if(!item.is_required)
	    	{	    		
	    		if(submission_made)
	    		{
	    			completion = true
	    		}
	    		else
	    		{
	    			
	    			completion = false
	    		}
	    		
	    		submittable =true
	    	}

	    	if(!item.show_field)
	    	{
	    		completion = false
	    		submittable =true
	    	}
	    	

	    	if(submission && submission.is_nulled)
	    	{
	    		completion = true
	    		submittable =true
	    		//show_evidence_btn = false
	    	}

	    	if(submission_made && item.submission_note_show_type=="on_input")
	    	{
	    		show_info_textarea = true
	    	}

	    	let evaluation_data = this.$store.state.evaluation.evaluation

	    	let user = this.$store.state.auth.user

	    	if(user.userroles && user.userroles.length)
	    	{
	    		let userroles = user.userroles.map((element)=>{return element.name})

	    		if(userroles.includes("supplier"))
	    		{
	    			if(evaluation_data.flow.type=="verification")
	    			{
	    				read_only_state = true
	    			}
	    			else
	    			{
	    				if(evaluation_data.status=="finished" || evaluation_data.status=="under_review" || evaluation_data.status=="canceled" || evaluation_data.status=="correction_requested")
		    			{
		    				read_only_state = true
		    			}
	    			}
	    			
	    		}
	    		else if(userroles.includes("brand"))
	    		{
	    			read_only_state = true
	    		}
	    		else
	    		{
	    			if(userroles.includes("admin") || userroles.includes("auditor") || userroles.includes("planner"))
	    			{
	    				if(this.$store.state.evaluation.viewingmode=="admin_submitting")
	    				{
	    					read_only_state = false
	    				}
	    				else
	    				{
	    					read_only_state = true
	    				}
	    				
	    			}
	    			else
	    			{
	    				read_only_state = true
	    			}
	    			
	    		}

	    		if(userroles.includes("supplier") && store.state.evaluation.evaluation.flow.type=="audit")
		    	{
		    		read_only_state = true
		    	}
	    	}



	    	
	    	item.completion = completion
	    	item.submittable = submittable
	    	item.show_evidence_btn = show_evidence_btn
	    	item.show_info_textarea = show_info_textarea
	    	item.read_only_state = read_only_state
	    	item.show_completion_indicator = show_completion_indicator
	    	item.read_only_question = read_only_question


	    	return item


	    },
	    checkInputfieldCompletion(item)
	    {	    	
	    	if(item.is_required && item.show_field && !item.submissions.length)
	    	{

	    		item.completion = false
	    		item.show_evidence_btn = false
	    		return item
	    	}
	    	else
	    	{   
				if(item.show_field ===0)
				{					
					item.completion = true
					item.show_evidence_btn = false
    				return item
				}

	    		let submission = item.submissions[0]

	    		if(!submission)
	    		{
	    			item.completion = false
	    			item.show_evidence_btn = false
    				return item
	    		}


	    		if(submission.is_nulled ===1)
				{					
					item.completion = true
					item.show_evidence_btn = false
    				return item
				}

	    		
				
				if(item.submission_note_required  && !submission.submission_note)
				{					
					item.completion = false
    				return item
				}



	    		//type- number
				if(item.type=="number" )
				{
					
					if(submission.submission_numerical || submission.submission_numerical !=="")
					{						
						if(item.is_evindence_required ===1 && !submission.evidences.length)
						{
							item.completion = false
							item.show_evidence_btn = true
		    				return item
						}
						else
						{
							item.completion = true
							item.show_evidence_btn = true
		    				return item
						}
						
					}
					else
					{
						item.completion = false
						item.show_evidence_btn = false
		    			return item
					}
				}
				//type- number
				//type- text,longtext,listselect
				if(item.type=="text"||item.type=="longtext"  || item.type=="listselect" || item.type=="multiselect")
				{
					if(!submission.submission_text || submission.submission_text=="[]")
					{
						item.completion = false
						item.show_evidence_btn = false
		    			return item
					}					
					else
					{	
		    			if(item.is_evindence_required)
						{
							if(!submission.evidences.length)
							{
								item.completion = false
								item.show_evidence_btn = true
			    				return item
							}
							else
							{

								item.completion = true
								item.show_evidence_btn = true
			    				return item
							}
							
						}
						else
						{
							
							item.completion = true
							item.show_evidence_btn = false
		    				return item
						}
					}
					
				}
				//type- text,longtext,listselect
				//type- columns
				if( item.type=="columns" )
				{
					if(submission.submission_text)
					{
						let submission_parsed = JSON.parse(submission.submission_text)	
						let input_columns = item.columns.filter((thecolumn)=>{return thecolumn.type!=="readonly"})
						for(let input_column of input_columns)
						{
							let input_column_submission = submission_parsed.find((item)=>{return item.id == input_column.id})
							if(input_column_submission)
							{
								input_column.submission = input_column_submission.value
							}
							else
							{
								input_column_submission = null
							}
						}
						console.log("input_columns")
						console.log(input_columns)

						
						//if some input is enough
						if(item.any_submission_full_points)
						{
							console.log("any_submission_full_points")
							
							for (let i = 0; i < input_columns.length; i++) {
							  if(input_columns[i].submission || input_columns[i].submission!=="")
								{
									if(item.is_evindence_required ===1 && !submission.evidences.length)
									{
										item.completion = false
										item.show_evidence_btn = true
									}
									else
									{
										item.completion = true
										item.show_evidence_btn = false
									}
									break;
								}
								
							}
							return item

						}
						//if some input is enough
						//if some input is not enough
						else
						{
							console.log("not any_submission_full_points")
							

							for (let i = 0; i < input_columns.length; i++) {
							  if(!input_columns[i].submission || input_columns[i].submission=="")
								{
									item.completion = false
									item.show_evidence_btn = false									
		    						break;
								}
								else
								{
									if(item.is_evindence_required ===1 && !submission.evidences.length)
									{
										item.completion = false
										item.show_evidence_btn = true
									}
									else
									{
										item.completion = true
										item.show_evidence_btn = false
									}
								}
								
							}
							return item

							
						}
						//if some input is not enough
							

						
					}
					else
					{
						item.completion = false
						item.show_evidence_btn = false
		    			return item
					}
					
				}
				//type- columns
				//type- select
				if(item.type=="select" )
				{



					if(!submission.submission_option || submission.submission_option=="")
					{
						item.completion = false
						item.show_evidence_btn = false
		    			return item
					}					
					else
					{	
		    			if(item.is_evindence_required)
						{
							if(!submission.evidences.length)
							{
								item.completion = false
								item.show_evidence_btn = true
			    				return item
							}
							else
							{

								item.completion = true
								item.show_evidence_btn = true
			    				return item
							}
							
						}
						else
						{
							
							item.completion = true
							item.show_evidence_btn = false
		    				return item
						}
					}


					
					
				}
				//type- select

				//type- boolean
				if(item.type=="boolean")
				{
					if(submission.submission_option===1)
					{
						
		    			if(item.is_evindence_required ===1 && !submission.evidences.length)
						{
							item.completion = false
							item.show_evidence_btn = true
		    				return item
						}
						else
						{
							item.completion = true
							item.show_evidence_btn = true
		    				return item
						}
					}
					else if(submission.submission_option===0)
					{
						if(item.is_evindence_required ===1 && !submission.evidences.length)
						{
							item.completion = false
							item.show_evidence_btn = true
		    				return item
						}
						else
						{
							item.completion = true
							item.show_evidence_btn = true
		    				return item
						}
					}
					else
					{
						item.completion = false
						item.show_evidence_btn = false
		    			return item
					}
					
				}
				//type- boolean
	    		
	    	}
	    },

	    executeInputfieldCondition(inputfield_id,condition,action)
	    {
	    	if(condition.selected_inputfield_switch=="show_field" ||
	    		condition.selected_inputfield_switch=="is_required" ||
	    		condition.selected_inputfield_switch=="is_nullable"
	    		)
	    	{
	    		let switch_state =  condition.selected_inputfield_switch_state
	    		if(action && action=="reverse")
	    		{
	    			switch_state = !switch_state;
	    		}

	    		let affected_item = this.$store.state.evaluation.inputfields.findIndex((item)=>{return item.id == inputfield_id})
		    	this.$store.state.evaluation.inputfields[affected_item][condition.selected_inputfield_switch] = switch_state
		    	/*
		    	if(this.$store.state.evaluation.active_section)
		    	{
		    		let active_section_affected_item = this.$store.state.evaluation.active_section.inputfields.findIndex((item)=>{return item.id == inputfield_id})	    	
		    		if(active_section_affected_item!==-1)
		    		{
		    			this.$store.state.evaluation.active_section.inputfields[active_section_affected_item][condition.selected_inputfield_switch] = switch_state
		    		}
					
		    	}
		    	*/

	    	}
	    	
	    	

	    	

	    },
	    checkInputfieldConditions(inputfield_id)
	    {
	    	
	    	let inputfield = this.$store.state.evaluation.inputfields.find((item)=>{return item.id == inputfield_id})
	    	let submission
	    	if(inputfield.submissions.length)
	    	{
	    		submission = inputfield.submissions[0]
	    	}
	    	else
	    	{
	    		return false
	    	}
	    	let control_value

	    	if(inputfield.type=="text" || inputfield.type=="longtext")
	    	{
	    		return false
	    	}

	    	if(inputfield.type=="select")
	    	{
	    		control_value = submission.submission_option
	    	}

	    	if(inputfield.type=="multiselect")
	    	{
	    		control_value = JSON.parse(submission.submission_text)
	    	}
	    	if(inputfield.conditions.length)
	    	{
	    		for(let condition of inputfield.conditions)
	    		{
	    			//check select
	    			if(inputfield.type=="select" )
	    			{
	    				//check inputfield effects
	    				if(condition.affected_item_type == "inputfield")
		    			{
		    				let selected_inputfield = condition.selected_inputfield
		    				if(control_value)
		    				{
		    					if(control_value==condition.selected_inputfield_option)
			    				{
			    					this.executeInputfieldCondition(selected_inputfield,condition)
			    				}
			    				else
			    				{
			    					this.executeInputfieldCondition(selected_inputfield,condition,"reverse")
			    				}

		    				}
		    				
		    			}
		    			//check inputfield effects
	    			}
	    			//check select

	    			//check multiselect
	    			if(inputfield.type=="multiselect" )
	    			{
	    				//check inputfield effects
	    				if(condition.affected_item_type == "inputfield")
		    			{
		    				let selected_inputfield = condition.selected_inputfield
		    				if(control_value.length)
		    				{
		    					if(control_value.includes(condition.selected_inputfield_option))
			    				{
			    					this.executeInputfieldCondition(selected_inputfield,condition)
			    				}
			    				else
			    				{
			    					this.executeInputfieldCondition(selected_inputfield,condition,"reverse")
			    				}
		    				}
		    				
		    			}
		    			//check inputfield effects
	    			}
	    			//check multiselect

	    			
	    			
	    		}
	    	}
	    	
	    },
	    submitMutatedSubmission(inputfield,type,data)
	    {
	    	console.log("submitMutatedSubmission")
	    	let formdata = new FormData()
	    	formdata.append("type","select")
  			formdata.append("flowsupplier_id",store.state.evaluation.evaluation.uuid)
  			if(type=="select")
  			{
  				formdata.append("option",data)  
  				this.silentSubmitInputFieldSubmission(formdata,inputfield.id) 				
  								
  			}  			
  			
  			
	    },
	    checkQueslionlistConditions()
	    {
	    	console.log("checkQueslionlistConditions")
	    	let questionlist_conditions = this.$store.state.evaluation.questionlist_conditions
	    	//loop questionlist_conditions
	    	
	    	
	    	for (let ii = 0; ii <questionlist_conditions.length; ii++) 
	    	{
	    		let questionlist_condition = questionlist_conditions[ii]
	    		
	    		let conditions_met = false
	    		let condition_break = false
	    		let conditions = questionlist_condition.conditions

	    		// loop conditions
	    		for (let i = 0; i <conditions.length; i++) 
	    		{
	    			
	    			//type inputfield
	    			if(conditions[i].inputfield_id)
	    			{
	    				let subject_inputfield = this.$store.state.evaluation.inputfields.find((item)=>{return item.id == conditions[i].inputfield_id})
	    				
	    				//dispose missing inputfield
	    				if(!subject_inputfield && conditions[i].operator !=="or")
	    				{	
	    					conditions_met = false
	    					condition_break = true
	    					break
	    				}

	    				//dispose missing inputfield
	    				

		    			// text,longtext
		    			if(subject_inputfield.type=="text" || subject_inputfield.type=="longtext")
		    			{
		    				if(subject_inputfield.submissions && subject_inputfield.submissions.length && subject_inputfield.submissions[0].submission_text!=="")
		    				{
		    					let submitted_val = subject_inputfield.submissions[0].submission_text
		    					if(submitted_val && submitted_val.includes(conditions[i].text_val))
		    					{
		    						if(conditions[i].operator=="or")
		    						{
		    							conditions_met = true
		    							break
		    						}
		    						else
		    						{
		    							conditions_met = true
		    						}
		    					}
		    				}
		    			}
		    			// text,longtext
		    			// number
		    			if(subject_inputfield.type=="number")
		    			{
		    				if(subject_inputfield.submissions && subject_inputfield.submissions.length && subject_inputfield.submissions[0].submission_numerical!=="")
		    				{
		    					let submitted_val = subject_inputfield.submissions[0].submission_numerical
		    					//equal_to
		    					if(conditions[i].execution_type=='equal_to' && submitted_val==conditions[i].numerical_val)
		    					{
		    						if(conditions[i].operator=="or")
		    						{
		    							conditions_met = true
		    							break
		    						}
		    						else
		    						{
		    							conditions_met = true
		    						}
		    					}
		    					//equal_to
		    					//not_equal_to
		    					if(conditions[i].execution_type=='not_equal_to' && submitted_val!==conditions[i].numerical_val)
		    					{
		    						if(conditions[i].operator=="or")
		    						{
		    							conditions_met = true
		    							break
		    						}
		    						else
		    						{
		    							conditions_met = true
		    						}
		    					}
		    					//not_equal_to
		    					//greater_than
		    					if(conditions[i].execution_type=='greater_than' && submitted_val>conditions[i].numerical_val)
		    					{
		    						if(conditions[i].operator=="or")
		    						{
		    							conditions_met = true
		    							break
		    						}
		    						else
		    						{
		    							conditions_met = true
		    						}
		    					}
		    					//greater_than
		    					//less_than
		    					if(conditions[i].execution_type=='less_than' && submitted_val<conditions[i].numerical_val)
		    					{
		    						if(conditions[i].operator=="or")
		    						{
		    							conditions_met = true
		    							break
		    						}
		    						else
		    						{
		    							conditions_met = true
		    						}
		    					}
		    					//less_than

		    				}
		    			}
		    			// number
		    			// boolean,select
		    			if(subject_inputfield.type=="boolean" || subject_inputfield.type=="select")
		    			{
		    				if(subject_inputfield.submissions && subject_inputfield.submissions.length && subject_inputfield.submissions[0].submission_option!=="")
		    				{
		    					let submitted_val = subject_inputfield.submissions[0].submission_option
		    					//equal_to
		    					if(conditions[i].execution_type=='equal_to' && submitted_val==conditions[i].numerical_val)
		    					{
		    						if(conditions[i].operator=="or")
		    						{
		    							conditions_met = true
		    							break
		    						}
		    						else
		    						{
		    							conditions_met = true
		    						}
		    					}
		    					//equal_to
		    					//not_equal_to
		    					if(conditions[i].execution_type=='not_equal_to' && submitted_val!==conditions[i].numerical_val)
		    					{
		    						if(conditions[i].operator=="or")
		    						{
		    							conditions_met = true
		    							break
		    						}
		    						else
		    						{
		    							conditions_met = true
		    						}
		    					}
		    					//not_equal_to
		    				}
		    			}
		    			// boolean,select
		    			// multiselect
		    			if(subject_inputfield.type=="multiselect")
		    			{
		    				if(subject_inputfield.submissions && subject_inputfield.submissions && subject_inputfield.submissions.length && subject_inputfield.submissions[0].submission_text!=="")
		    				{
		    					
		    					let submitted_val = JSON.parse(subject_inputfield.submissions[0].submission_text)
		    					if(conditions[i].execution_type=='equal_to' && submitted_val&& submitted_val.includes(conditions[i].numerical_val))
		    					{
		    						if(conditions[i].operator=="or")
		    						{
		    							conditions_met = true
		    							break
		    						}
		    						else
		    						{
		    							conditions_met = true
		    						}
		    					}
		    					//equal_to
		    					//not_equal_to
		    					if(conditions[i].execution_type=='not_equal_to' && submitted_val&& !submitted_val.includes(conditions[i].numerical_val))
		    					{
		    						if(conditions[i].operator=="or")
		    						{
		    							conditions_met = true
		    							break
		    						}
		    						else
		    						{
		    							conditions_met = true
		    						}
		    					}
		    					//not_equal_to
		    				}
		    			}
		    			// multiselect
		    			// listselect
		    			if(subject_inputfield.type=="listselect")
		    			{

		    			}
		    			// listselect

		    			// columns
		    			if(subject_inputfield.type=="columns")
		    			{
		    				
		    				
		    				if(subject_inputfield.submissions && subject_inputfield.submissions.length && subject_inputfield.submissions[0].submission_text && subject_inputfield.submissions[0].submission_text!=="" )
		    				{
		    					let submitted_val = JSON.parse(subject_inputfield.submissions[0].submission_text)
		    					
		    					let submitted_column = submitted_val.find(element => element.id == conditions[i].inputfieldcolumn_id)
		    					if(submitted_column)
		    					{

		    						

		    						let condition_numerical_val
		    						if(conditions[i].comparison_type=="inputfield")
		    						{
		    							
		    							let comparison_inputfield = this.$store.state.evaluation.inputfields.find(element=>element.id == conditions[i].comparison_inputfield_id)
		    							if(comparison_inputfield && comparison_inputfield.submissions.length)
		    							{
		    								
		    								if(comparison_inputfield.type=="columns" && comparison_inputfield.submissions[0].submission_text)
		    								{
		    									
		    									let comparison_sub_text = JSON.parse(comparison_inputfield.submissions[0].submission_text)
		    									let comparison_column = comparison_sub_text.find(element=>element.id == conditions[i].comparison_inputfield_column_id)
		    									if(comparison_column && comparison_column.value)
		    									{
		    										
		    										condition_numerical_val = comparison_column.value
		    									}
		    								}
		    								if(comparison_inputfield.type=="number")
		    								{

		    								}

		    							}
		    						}
		    						else
		    						{
		    							condition_numerical_val = conditions[i].numerical_val
		    						}
		    						
		    						//inpu_filled
		    						if(conditions[i].execution_type=='inpu_filled' && submitted_column.value)
		    						{
		    							
		    							
		    							if(conditions[i].operator=="or")
			    						{
			    							conditions_met = true
			    							break
			    						}
			    						else
			    						{
			    							conditions_met = true
			    						}
		    						}
		    						//inpu_filled
		    						//equal_to
		    						if(conditions[i].execution_type=='equal_to' && submitted_column.value==condition_numerical_val)
		    						{
		    							if(conditions[i].operator=="or")
			    						{
			    							conditions_met = true
			    							break
			    						}
			    						else
			    						{
			    							conditions_met = true
			    						}
		    						}
		    						//equal_to
		    						//not_equal_to
		    						if(conditions[i].execution_type=='not_equal_to' && submitted_column.value!==condition_numerical_val)
		    						{
		    							if(conditions[i].operator=="or")
			    						{
			    							conditions_met = true
			    							break
			    						}
			    						else
			    						{
			    							conditions_met = true
			    						}
		    						}		    						
		    						//not_equal_to
		    						//greater_than
		    						if(conditions[i].execution_type=='greater_than' && submitted_column.value>condition_numerical_val)
		    						{
		    							if(conditions[i].operator=="or")
			    						{
			    							conditions_met = true
			    							break
			    						}
			    						else
			    						{
			    							conditions_met = true
			    						}
		    						}		    						
		    						//greater_than
		    						//less_than
		    						if(conditions[i].execution_type=='less_than' && submitted_column.value<condition_numerical_val)
		    						{
		    							console.log("LESS THEN")
		    							if(conditions[i].operator=="or")
			    						{
			    							conditions_met = true
			    							break
			    						}
			    						else
			    						{
			    							conditions_met = true
			    						}
		    						}		    						
		    						//less_than
		    					}
		    				}
		    			}
		    			// columns



	    			}
	    			//type inputfield
	    			//type customattribute
	    			if(conditions[i].customattribute_id)
	    			{
	    				let subject_customattribute = this.$store.state.evaluation.customattributes.find((item)=>{return item.id == conditions[i].customattribute_id})
	    				
	    				if(subject_customattribute)
	    				{
	    					// boolean,select
			    			if( subject_customattribute.type=="select" || subject_customattribute.type=="boolean")
			    			{
			    				if(subject_customattribute.supplierattributes.length && subject_customattribute.supplierattributes[0].attibutenumericalval!=="")
			    				{
			    					let submitted_val = subject_customattribute.supplierattributes[0].attibutenumericalval
			    					//equal_to
			    					if(conditions[i].execution_type=='equal_to' && submitted_val==conditions[i].numerical_val)
			    					{
			    						if(conditions[i].operator=="or")
			    						{
			    							conditions_met = true
			    							break
			    						}
			    						else
			    						{
			    							conditions_met = true
			    						}
			    					}
			    					//equal_to
			    					//not_equal_to
			    					if(conditions[i].execution_type=='not_equal_to' && submitted_val!==conditions[i].numerical_val)
			    					{
			    						if(conditions[i].operator=="or")
			    						{
			    							conditions_met = true
			    							break
			    						}
			    						else
			    						{
			    							conditions_met = true
			    						}
			    					}
			    					//not_equal_to
			    				}
			    			}
			    			// boolean,select

	    				}
	    				
	    			}
	    			//type customattribute


	    			


	    		}
	    		// loop conditions
	    		if(conditions_met)
	    		{
	    			console.log("conditions_met")
	    			console.log(questionlist_condition.id)
	    			
	    			let outcomes = questionlist_condition.outcome
	    			for(let outcome of outcomes)
	    			{
	    				
	    				let inputfields = this.$store.state.evaluation.inputfields
	    				let ind = inputfields.findIndex((item)=>{return item.id == outcome.inputfield_id})
	    				let inputfieldsections = this.$store.state.evaluation.sections 
	    				let section_ind = inputfieldsections.findIndex((item)=>{return item.id == outcome.inputfieldsection_id})
	    				


	    				if(outcome.type=="inputfieldsection" && section_ind!==-1)
	    				{
	    					
	    					if(outcome.execution_type=="show_field")
	    					{
	    						outcome.execution_type = "show_section"
	    					}
	    					
	    					inputfieldsections[section_ind][outcome.execution_type] = outcome.numerical_val
	    					if(inputfieldsections[section_ind].mutated_properties && inputfieldsections[section_ind].mutated_properties.length)
	    					{
	    						let mutated_ind = inputfieldsections[section_ind].mutated_properties.findIndex((item)=>{return item.type==outcome.execution_type})
	    						if(mutated_ind==-1)
	    						{
	    							inputfieldsections[section_ind].mutated_properties.push({type:outcome.execution_type,numerical_val:outcome.numerical_val}) 
	    						}
	    					}
	    					else
	    					{
	    						inputfieldsections[section_ind].mutated_properties = [{type:outcome.execution_type,numerical_val:outcome.numerical_val}]
	    					}
	    				}
	    				store.dispatch('evaluation/setSections',inputfieldsections)

	    				if(outcome.type=="inputfield" && ind!==-1)
	    				{
	    					
	    					//not points
	    					if(outcome.execution_type!=="points")
		    				{
		    					
		    					inputfields[ind][outcome.execution_type] = outcome.numerical_val
		    					let mutated_property = {
		    						type:outcome.execution_type,
		    						numerical_val:null,
		    						effected_column:null,
		    					}
		    					//not inputfield
		    					if(outcome.comparison_type!=="inputfield")
		    					{
		    						
		    						//if column
		    						if(outcome.inputfieldcolumn_id)
		    						{
		    							let inputfield_ind = inputfields.findIndex(element=>element.id == outcome.inputfield_id)
		    							let col_ind = inputfields[inputfield_ind].columns.findIndex(element=>element.id == outcome.inputfieldcolumn_id)
		    							inputfields[inputfield_ind].columns[col_ind][outcome.execution_type] = outcome.numerical_val
		    							//if value
		    							if(outcome.execution_type=="value")
		    							{
		    								if(!inputfields[inputfield_ind].submissions.length)
		    								{
		    									let the_submission_obj = {
		    										id:outcome.inputfieldcolumn_id,
		    										value:outcome.numerical_val
		    									}
		    									let the_submission = {submission_text:JSON.stringify(the_submission_obj)}
		    									inputfields[inputfield_ind].submissions.push(the_submission)
		    								}
		    								else
		    								{
		    									let the_submission = inputfields[inputfield_ind].submissions[0]
		    									let the_submission_text = JSON.parse(the_submission.submission_text)
		    									let mutated_column_ind = the_submission_text.findIndex(item=>item.id == outcome.inputfieldcolumn_id)
		    									if(mutated_column_ind!==-1)
		    									{
		    										the_submission_text[mutated_column_ind].value = outcome.numerical_val
		    										the_submission.submission_text = JSON.stringify(the_submission_text)
		    									}
		    									else
		    									{
		    										let the_submission_obj = {
			    										id:outcome.inputfieldcolumn_id,
			    										value:outcome.numerical_val
			    									}
			    									the_submission_text.push(the_submission_obj)
			    									the_submission.submission_text = JSON.stringify(the_submission_text)
		    									}
		    									inputfields[inputfield_ind].submissions[0] = the_submission
		    								}

		    								inputfields[inputfield_ind].columns[col_ind].is_nulled = true		    								
		    							}//if value
		    						}
		    						//if column
		    						//if not column
		    						else
		    						{
		    							if(outcome.execution_type=="value")
		    							{
		    								let inputfield_ind = inputfields.findIndex(element=>element.id == outcome.inputfield_id)
			    							
			    							

			    							//select
			    							if(inputfields[inputfield_ind].type=="select")
			    							{
			    								if(outcome.numerical_val)
				    							{
				    								let the_submission = {submission_option:outcome.numerical_val}
				    								//about altering submission
				    								if(!inputfields[inputfield_ind].submissions.length)
				    								{		
				    									
				    									inputfields[inputfield_ind].submissions.push(the_submission)
				    									this.submitMutatedSubmission(inputfields[inputfield_ind],"select",outcome.numerical_val)
				    								}
				    								else
				    								{	    							
				    									if(inputfields[inputfield_ind].submissions[0].submission_option !== outcome.numerical_val)	
				    									{
				    										
				    										inputfields[inputfield_ind].submissions[0] = the_submission
				    										this.submitMutatedSubmission(inputfields[inputfield_ind],"select",outcome.numerical_val)
				    									}			    									
				    								}
				    								//about altering submission

			    									inputfields[inputfield_ind].is_nulled = true

			    									/*
			    									if(!inputfields[ind].mutated_properties || !inputfields[ind].mutated_properties.length)
			    									{
			    										this.submitMutatedSubmission(inputfields[inputfield_ind],"select",outcome.numerical_val)
			    									}
			    									else
			    									{
			    										console.log("has mutated_property")
			    										let the_mutaded_property = inputfields[ind].mutated_properties.find(item=>item.type=="value" && item.numerical_val==outcome.numerical_val)
			    										if(!the_mutaded_property)
			    										{
			    											
			    										}
			    									}
			    									*/
			    									
				    											    								
				    							}
			    							}
			    							//select

			    							mutated_property.numerical_val = outcome.numerical_val
		    							}
		    							
		    						}
		    						//if not column
		    					}
		    					//not inputfield
		    					//inputfield
		    					if(outcome.comparison_type=="inputfield")
		    					{		    						
		    						let comp_inputfield_ind = inputfields.findIndex(element=>element.id == outcome.comparison_inputfield_id)
		    						if(comp_inputfield_ind!==-1)
		    						{
		    							
		    							if(outcome.inputfieldcolumn_id)
		    							{		    								
		    								mutated_property.effected_column = outcome.inputfieldcolumn_id
		    							}

		    							if(inputfields[comp_inputfield_ind].type=="columns")
		    							{		    								
		    								//console.log("COLUMN MODİFY")
		    								let comp_sub_text = inputfields[comp_inputfield_ind].submissions[0].submission_text
		    								if(comp_sub_text && comp_sub_text!=="" && outcome.comparison_inputfield_column_id)
		    								{		    									
		    									comp_sub_text = JSON.parse(comp_sub_text)
		    									let comp_sub = comp_sub_text.find(element=>element.id == outcome.comparison_inputfield_column_id)
		    									if(comp_sub)
		    									{
		    										
		    										let col_ind = inputfields[comp_inputfield_ind].columns.findIndex(element => element.id == outcome.inputfieldcolumn_id)
		    										if(col_ind!==-1)
		    										{		    											
		    											mutated_property.numerical_val = comp_sub.value
		    											inputfields[comp_inputfield_ind].columns[col_ind][outcome.execution_type] = comp_sub.value
		    											
		    										}
		    										
		    									}
		    								}
		    							}
		    							if(inputfields[comp_inputfield_ind].type=="number")
		    							{
		    								mutated_property.numerical_val = inputfields[comp_inputfield_ind].submissions[0].submission_numerical
		    							}		    							
		    						}

		    					}
		    					//inputfield
		    					else
		    					{
		    						//mutated_property.numerical_val = outcome.numerical_val
		    					}

		    					if(inputfields[ind].mutated_properties && inputfields[ind].mutated_properties.length)
		    					{
		    						
		    						let mutated_ind = inputfields[ind].mutated_properties.findIndex((item)=>{return item.type==outcome.execution_type})
		    						if(mutated_ind==-1)
		    						{
		    							inputfields[ind].mutated_properties.push(mutated_property) 
		    						}
		    					}
		    					else
		    					{
		    						inputfields[ind].mutated_properties = [mutated_property]
		    					}
		    					
		    					//inputfields[ind].mutated_properties = {type:outcome.execution_type}
		    				}
	    				}
	    				store.dispatch('evaluation/setInputfields',inputfields)	    				
	    			}
	    		}
	    		//reverse actions
	    		else
	    		{
	    			
	    			//condition requirements met
	    			if(!condition_break)
					{
						let outcomes = questionlist_condition.outcome
		    			for(let outcome of outcomes)
		    			{
		    				
		    				let inputfields = this.$store.state.evaluation.inputfields
		    				let ind = inputfields.findIndex((item)=>{return item.id == outcome.inputfield_id}) 
		    				let inputfieldsections = this.$store.state.evaluation.sections 
		    				let section_ind = inputfieldsections.findIndex((item)=>{return item.id == outcome.inputfieldsection_id})
		    				
		    				if(outcome.type=="inputfieldsection")
		    				{
		    					
		    					if(inputfieldsections[section_ind].mutated_properties && inputfieldsections[section_ind].mutated_properties.length)
		    					{
		    						let theind = inputfieldsections[section_ind].mutated_properties.findIndex((item)=>{return item.type==outcome.execution_type})
		    						if(theind==!-1)
		    						{
		    							inputfieldsections[section_ind].mutated_properties = inputfieldsections[section_ind].mutated_properties.filter((item)=>{return item.type !==outcome.execution_type})
		    							inputfieldsections[section_ind][outcome.execution_type] = !inputfieldsections[section_ind][outcome.execution_type]
		    						}
		    						//inputfields[ind].mutated_property = null
		    						
		    					}
		    				}
		    				store.dispatch('evaluation/setSections',inputfieldsections)
		    				
		    				if(outcome.type=="inputfield")
		    				{

		    					if(outcome.execution_type!=="points")
			    				{
			    					
			    					if(inputfields[ind].mutated_properties && inputfields[ind].mutated_properties.length)
			    					{

			    						let theind = inputfields[ind].mutated_properties.findIndex((item)=>{return item.type==outcome.execution_type})
			    						if(theind!==-1)
			    						{
			    							if(outcome.execution_type=="min_value" || outcome.execution_type=="max_value")
		    								{
		    									if(inputfields[ind].mutated_properties[theind] && inputfields[ind].mutated_properties[theind].effected_column)
		    									{
		    										let col_ind = inputfields[ind].columns.findIndex(element=>element.id == inputfields[ind].mutated_properties[theind].effected_column)
				    								inputfields[ind].columns[col_ind][outcome.execution_type] = null
		    									}
		    									//if effected column
		    									//if not effected column
		    									else
		    									{
		    										inputfields[ind][outcome.execution_type] = null
		    									}
		    									//if not effected column
		    								}
		    								//if other
		    								else
		    								{	    

		    									//if effected column									
			    								if(inputfields[ind].mutated_properties[theind] && inputfields[ind].mutated_properties[theind].effected_column)
				    							{
				    								
				    								let col_ind = inputfields[ind].columns.findIndex(element=>element.id == inputfields[ind].mutated_properties[theind].effected_column)
				    								inputfields[ind].columns[col_ind][outcome.execution_type] = !inputfields[ind].columns[col_ind][outcome.execution_type]
				    								inputfields[ind].mutated_properties = inputfields[ind].mutated_properties.filter((item)=>{return item.type !==outcome.execution_type})
			    									inputfields[ind][outcome.execution_type] = !inputfields[ind][outcome.execution_type]
				    							}
				    							//if effected column	
				    							//if not effected column	
				    							else
				    							{
				    								
				    								
				    								inputfields[ind].mutated_properties = inputfields[ind].mutated_properties.filter((item)=>{return item.type !==outcome.execution_type})
				    								
			    									
			    									if(outcome.execution_type=="value")
				    								{
				    									inputfields[ind].is_nulled = !inputfields[ind].is_nulled
				    								}
				    								else
				    								{
				    									inputfields[ind][outcome.execution_type] = !inputfields[ind][outcome.execution_type]
				    								}
				    							}
				    							//if not effected column
		    								}
		    								//if other		    							
			    							
			    						}
			    						//inputfields[ind].mutated_property = null		    						
			    					}
			    				}
		    				}	    				
		    				store.dispatch('evaluation/setInputfields',inputfields)	    				
		    			}
						
					}
					//condition requirements met
	    			
	    			
	    		}
	    		//reverse actions
	    	}
	    	//loop questionlist_conditions

	    },
	    arrangeAuditSectionInputfields(section_id)
	    {      
	        let sections = store.state.evaluation.sections.filter((item)=>{return item.parent_id == section_id && item.show_section})
	        sections  =  sections.sort(this.orderSection)
	        let active = store.state.evaluation.sections.find((item)=>{return item.id == section_id})
	        let inputfields = store.state.evaluation.inputfields.filter((item)=>{return item.inputfieldsection_id == section_id})

	        return {childsections:sections,section:active,inputfields:inputfields}
	    },
	    submitInputFieldSubmission(formdata,data_id)
		{
			//console.log("submitInputFieldSubmission")
			store.dispatch('evaluation/setInputfieldsUpdating',true)
			
			this.generalSubmission(formdata,"audit/submit_inputfield_submission/"+data_id,this.aftersubmitInputData)
		},
		silentSubmitInputFieldSubmission(formdata,data_id)
		{
			console.log("silentSubmitInputFieldSubmission")
			//store.dispatch('evaluation/setInputfieldsUpdating',true)
			
			this.silentSubmission(formdata,"audit/submit_inputfield_submission/"+data_id,this.aftersilentSubmitInputFieldSubmission)
		},
		async aftersilentSubmitInputFieldSubmission(response)
		{
			let inputfield = await response.data
			let all_fields = await this.$store.state.evaluation.inputfields
			let all_ind = await all_fields.findIndex((item)=>{return item.id == inputfield.id})	     
			all_fields[all_ind] = await inputfield
			await store.dispatch('evaluation/setInputfields',all_fields)
			for(let all_field of all_fields)
			{
				all_field = await this.checkSingleInputfieldCompletion(all_field)
			}
			await store.dispatch('evaluation/setInputfields',all_fields)
			await this.calculateEvaluationProgress()
		},
	    async aftersubmitInputData(response)
	    {
	    	console.log("aftersubmitInputData")
	    	console.log(response.data)
	    	store.dispatch('evaluation/setInputfieldsUpdating',true)
			//console.log(response.data)
			let inputfield = await response.data
			let all_fields = await this.$store.state.evaluation.inputfields
			let all_ind = await all_fields.findIndex((item)=>{return item.id == inputfield.id})	     
			all_fields[all_ind] = await inputfield
			await store.dispatch('evaluation/setInputfields',all_fields)
			await this.checkQueslionlistConditions()
			all_fields = await this.$store.state.evaluation.inputfields
			
			for(let all_field of all_fields)
			{
				all_field = await this.checkSingleInputfieldCompletion(all_field)
			}
			await store.dispatch('evaluation/setInputfields',all_fields)
	      
			//await store.dispatch('evaluation/setInputfieldsUpdating',true)
			


			//inputfield = await this.checkSingleInputfieldCompletion(inputfield)


			//all_fields[all_ind] = await inputfield

			if(this.$store.state.audit && this.$store.state.audit.questionlist && this.$store.state.audit.display=='questions')
			{
				await this.mapInputfieldsWithoutLoader()
			}
			await this.calculateEvaluationProgress()
			await store.dispatch('evaluation/setInputfieldsUpdating',false)
	    },
	    async getSingleInputfieldSubmissionData(inputfield_id)
	    {
	    	//get_single_inputfield_submission_data
	    	let data =  await this.generalApiGetWithoutLoader("audit/get_single_inputfield_submission_data/"+inputfield_id+"/"+store.state.evaluation.evaluation.uuid)
	    	console.log("getSingleInputfieldSubmissionData")
	    	console.log(data)
	    	let resp = {
	    		data:data
	    	}
	    	await this.aftersubmitInputData(resp)
	    },
	    calculateInputfieldProgress(obj,item,factor)
	    {
	    	if(item.submissions.length)
			{
				let submission = item.submissions[0]
				//type- number
				if(item.type=="number" )
				{
					if(submission.submission_numerical || submission.is_nulled ===1)
					{
						obj.processed_items++
						obj.progress_percentage += factor
						if(obj.progress_percentage>100)
						{
							obj.progress_percentage = 100
						}
					}
				}
				//type- number
				//type- text,longtext,listselect
				if(item.type=="text"||item.type=="longtext"  || item.type=="listselect")
				{
					if(submission.submission_text || submission.is_nulled ===1)
					{
						obj.processed_items++
						obj.progress_percentage += factor
						if(obj.progress_percentage>100)
						{
							obj.progress_percentage = 100
						}
					}
					
				}
				//type- text,longtext,listselect
				//type- columns
				if( item.type=="columns" )
				{
					if(submission.submission_text || submission.is_nulled ===1)
					{
						let submission_parsed = JSON.parse(submission.submission_text)								
						if(submission_parsed.length === item.columns.length)
						{
							if (submission_parsed.some(element => !element.value)) {
							  
							}
							else
							{
								obj.processed_items++
								obj.progress_percentage += factor
								if(obj.progress_percentage>100)
								{
									obj.progress_percentage = 100
							}
							}
							

						}
						
					}
					
				}
				//type- columns
				//type- select,boolean
				if(item.type=="select" || item.type=="boolean")
				{
					if(submission.submission_option || submission.is_nulled ===1)
					{
						obj.processed_items++
						obj.progress_percentage += factor
						if(obj.progress_percentage>100)
						{
							obj.progress_percentage = 100
						}
					}
					
				}
				//type- select,boolean
			}
			return  obj
	    },
	    checkInputfieldTypeForCompaltion(inputfield)
	    {


	    },
		async calculateEvaluationProgress()
		{
			let inputfields = store.state.evaluation.inputfields

			//inputfields = this.sanitizeArray(inputfields)
			/*
			for(let test of inputfields)
			{
				let vis = this.checkInputfieldSectionVisibility(test)
				console.log("test")
				console.log(vis)
				console.log(test)
			}
			*/

			inputfields = inputfields.filter((item)=>
			{
				//console.log(item)
				if(!item.hidden_by_section)
				{
					return item.show_field === 1 && item.show_completion_indicator 
				}
				
			})
			//console.log(inputfields)


			let factor = 100/inputfields.length
			let obj = {
				items:[],
				itemcount:inputfields.length,
				current_item:null,
				processed_items:0,
				progress_percentage:0
			}
			
			
			//loop inputfields
			for(let item of inputfields)
			{
				if(item.completion)
				{
					obj.processed_items++
					obj.progress_percentage += factor
					if(obj.progress_percentage>99.5)
					{
						obj.progress_percentage = Math.floor(obj.progress_percentage)
					}
					else
					{
						obj.progress_percentage = parseFloat(obj.progress_percentage.toFixed(2))
					}
					
					if(obj.progress_percentage>100)
					{
						obj.progress_percentage = 100
					}
				}
			}
			//loop inputfields

			let all_completed = true
			for (let i = 0; i < inputfields.length; i++) {
				if(!inputfields[i].completion)
				{
					all_completed = false
					break
				}
			}

			if(all_completed)
			{
				obj.progress_percentage = 100
			}

			store.dispatch('evaluation/setFlowProcess',obj)

		},
		async calculateEducationProgress(action)
		{
			let videos = this.sanitizeArray(store.state.evaluation.flow_videos.videos)			
			let factor = Math.ceil(100/videos.length)
			let obj = {
				items:videos,
				itemcount:videos.length,
				current_item:null,
				processed_items:0,
				progress_percentage:0
			}

			if(action=="first_init")
			{
				
			
				store.dispatch('evaluation/setFlowProcess',obj)
				
				//loop videos
				for(let item of videos)
				{
					if(item.progresses.length)
					{
						let progress = item.progresses[0]
						if(progress.status=="ended")
						{
							obj.processed_items++
							obj.progress_percentage += factor
							if(obj.progress_percentage>100)
							{
								obj.progress_percentage = 100
							}
						}
					}
				}
				//loop videos

			}
			if(action=="next_video")
			{
				console.log("next_video")
				obj = store.state.evaluation.flow_process
				obj.processed_items++
				obj.progress_percentage += factor
				
			}
			

			store.dispatch('evaluation/setFlowProcess',obj)
		},

		async resolveCalculateColumnData(column)
		{
			console.log("resolveCalculateColumnData")
			let calculation = JSON.parse(column.calculation) 
			let nodes = calculation.nodes
	  		let connections = calculation.connections
	  		let remote_requests = []
	  		let equation = nodes.find((item)=>{return item.type=="equation"})
	  		let output
	  		if(equation)
	  		{
	  			let equation_connection = connections.find((item)=>{return item.to == equation.id})
		  		if(equation_connection)
		  		{
		  			let last_operation = nodes.find((item)=>{return item.id == equation_connection.from})
		  			output = await this.getOperatorNodeOutputForCalculatedColumn(last_operation,nodes,connections,column,remote_requests)
		  			console.log("output")
		  			console.log(output)
		  			
		  		}
	  		}
	  		
	  		return await output
		},
		async getOperatorNodeOutputForCalculatedColumn(operator,nodes,connections,column,remote_requests)
	    {
	      let node_input_1 = operator.input1
	      let node_input_2 = operator.input2
	      let node_input_1_value 
	      let node_input_2_value 
	      let output
	      //get input 1 value
	      if(node_input_1)
	      {
	        if(node_input_1.type=="value")
	        {
	          node_input_1_value = node_input_1.value
	        }
	        if(node_input_1.type=="connection")
	        {
	          let connection = connections.find((item)=>{return item.id == node_input_1.connection_id})
	          let input_node = nodes.find((item)=>{return item.id == connection.from})
	          let outputobj = await this.getNodeOutputForCalculatedColumn(input_node,nodes,connections,column,remote_requests)
	          node_input_1_value = outputobj.output
	          remote_requests = outputobj.remote_requests
	        }
	      }
	      //get input 1 value
	      //get input 2 value
	      if(node_input_2)
	      {
	        if(node_input_2.type=="value")
	        {
	          node_input_2_value = node_input_2.value
	        }
	        if(node_input_2.type=="connection")
	        {
	          let connection = connections.find((item)=>{return item.id == node_input_2.connection_id})
	          let input_node = nodes.find((item)=>{return item.id == connection.from})
	          let outputobj = await this.getNodeOutputForCalculatedColumn(input_node,nodes,connections,column,remote_requests)
	          node_input_2_value = outputobj.output
	          remote_requests = outputobj.remote_requests   
	        }
	      }
	      //get input 2 value
	      
	      if(operator.type=="addition" || operator.type=="subtraction")
	      {
	        if(column.calculate_with_zero)
	        {
	          if(!node_input_1_value || isNaN(node_input_1_value))
	          {
	            node_input_1_value = 0
	          }
	          if(!node_input_2_value || isNaN(node_input_2_value))
	          {
	            node_input_2_value = 0
	          }
	        }
	        else
	        {
	          if(!node_input_1_value && node_input_1_value!==0)
	          {
	            //console.log("hit")
	            output = {
	            	output:null,
	            	remote_requests:remote_requests,
	            }
	            return output
	          }
	          if(!node_input_2_value && node_input_2_value!==0)
	          {
	             output = {
	            	output:null,
	            	remote_requests:remote_requests,
	            }
	            return output
	          }
	        }
	      }
	      if(operator.type=="addition")
	      {         
	        output = node_input_1_value+node_input_2_value        
	      }
	      if(operator.type=="subtraction")
	      {       
	        output = node_input_1_value-node_input_2_value
	      }
	      if(operator.type=="multiplication")
	      {        
	        if(!node_input_1_value || node_input_1_value!==0)
	        {         
	          
	        }
	        else
	        {
	          if(column.calculate_with_zero)
	          {
	            node_input_1_value = 1
	          }
	          else
	          {
	            //node_input_1_value = 0
	          }
	        }
	        if(!node_input_2_value || node_input_2_value!==0)
	        {         
	          
	        }
	        else
	        {
	          if(column.calculate_with_zero)
	          {
	            node_input_2_value = 1
	          }
	          else
	          {
	            //node_input_2_value = 0
	          }
	        }        
	        output = node_input_1_value*node_input_2_value
	      }
	      if(operator.type=="division")
	      {
	        if(!node_input_1_value || node_input_1_value!==0)
	        {
	          
	        }
	        else
	        {
	          if(column.calculate_with_zero)
	          {
	            node_input_1_value = 1
	          }
	          else
	          {
	            //node_input_1_value = 0
	          }
	        }
	        if(!node_input_2_value || node_input_2_value!==0)
	        {
	          
	        }
	        else
	        {
	          if(column.calculate_with_zero)
	          {
	            node_input_2_value = 1
	          }
	          else
	          {
	            //node_input_2_value = 0
	          }
	        }        
	        output = node_input_1_value/node_input_2_value
	      }
	      let outputresultobj = {
	      	output:output,
	      	remote_requests:remote_requests,
	      }
	      return await outputresultobj
	    },
	    async getNodeOutputForCalculatedColumn(input_node,nodes,connections,column,remote_requests)
	    {
	      let outputobj = {
	        remote_requests:remote_requests,
	        output:null
	      }

	      if(input_node.type=="variable")
	      {
	        let inputfield_submission
	        let ind = this.$store.state.evaluation.inputfields.findIndex((item)=>item.id == input_node.inputfield_id)
	        if(ind==-1)
	        {
	          let data_required_ind = remote_requests.findIndex(item=>item.id ==input_node.id)
	          if(data_required_ind==-1)
	          {
	            inputfield_submission = await  this.silentApiGet("get_inputfield_submission_by_period/"+input_node.inputfield_id+"/"+this.$store.state.evaluation.evaluation.supplier_id+"/"+input_node.period_id+"/"+this.$store.state.evaluation.evaluation.flow.type+"/"+this.$store.state.evaluation.evaluation.id)
	            let node_obj = {
	              id:input_node.id,
	              inputfield_submission:inputfield_submission
	            }
	            remote_requests.push(node_obj)
	          }
	          else
	          {
	            inputfield_submission = remote_requests[data_required_ind].inputfield_submission
	          }
	        }
	        else
	        {         
	          let local_inputfield = this.$store.state.evaluation.inputfields[ind]
	          if(local_inputfield.submissions.length)
	          {
	            inputfield_submission = local_inputfield.submissions[0]
	            inputfield_submission.inputfield = this.$store.state.evaluation.inputfields[ind]
	            if(inputfield_submission.is_nulled)
	            {
	              let the_null_reason = this.$store.state.evaluation.nullreasons.findIndex((item)=>item.id == inputfield_submission.null_reason)
	              if(the_null_reason ==-1)
	              {
	                inputfield_submission.nullreason = null
	              }
	              else
	              {
	                inputfield_submission.nullreason = this.$store.state.evaluation.nullreasons[the_null_reason]
	              }
	            }           
	          }
	        }

	        if(inputfield_submission && inputfield_submission.inputfield.type=="columns")
	        {
	          if(inputfield_submission.submission_text)
	          {
	            let columns_data = JSON.parse(inputfield_submission.submission_text) 
	            let the_column = columns_data.find((item)=>{return item.id == input_node.column_id})
	            if(!the_column)
	            {
	              outputobj.output = null
	              return outputobj
	            }
	            
	            if(the_column)
	            {
	              console.log("the_column")
	              let actual_column = inputfield_submission.inputfield.columns.find(item => item.id == the_column.id)


	              if(the_column.value || the_column.value ===0)
	              {
	              	console.log("the_column.value")
	                if(!inputfield_submission.is_nulled)
	                {
	                	console.log("column not nulled")
	                    if(actual_column.type=="select")
	                    {
	                      let actual_option = actual_column.options.find(item =>item.id == the_column.value)
	                      outputobj.output = parseFloat(actual_option.points)
	                    }
	                    else
	                    {
	                      console.log("colum no select")
	                      console.log(the_column)
	                      outputobj.output = the_column.value
	                    }
	                }
	                else
	                {
	                  if(inputfield_submission.nullreason && inputfield_submission.nullreason.full_points_selected)
	                  {                   
	                    if(actual_column.type=="select")
	                    {                      
	                      let actual_option = actual_column.options.find(item =>item.id == the_column.value)
	                      outputobj.output = parseFloat(actual_option.name)
	                    }
	                    else
	                    {
	                      outputobj.output = the_column.value
	                    }                                        
	                  }
	                }
	              }



	            }
	          }
	        }


	        if(inputfield_submission && inputfield_submission.inputfield.type=="number")
	        {
	          if(inputfield_submission.submission_numerical)
	            {
	              outputobj.output = inputfield_submission.submission_numerical
	            }
	        }

	        if(inputfield_submission)
	        {
	          
	        }  

	      }

	      if(input_node.type!=="variable")
	      {
	        outputobj = await this.getOperatorNodeOutputForCalculatedColumn(input_node,nodes,connections,column,remote_requests)
	      }
	      return await outputobj
	    },
	    submitCalculatedDataForColumn(column,data)
	  	{
	  		if(column.submit_to_db)
	  		{	
	  			let arr = this.sanitizeArray(this.$store.state.evaluation.calculated_data_to_submit)

	  			let obj = {
		  				id:column.id,
		  				flowsupplier_id:this.$store.state.evaluation.evaluation.uuid,
		  				inputfield_id:column.inputfield_id,
		  				data:data
		  			}

	  			let ind = arr.findIndex(item=>item.id == column.id)
	  			if(ind==-1)
	  			{
	  				arr.push(obj)
	  			}
	  			else
	  			{
	  				arr[ind] = obj
	  			}

	  			this.$store.dispatch('evaluation/setCalculatedDataToSubmit',arr) 
	  			return "ok"
	  		}
	  		
	  	},

	},
	//methods

}